/**
 * Normalize a description from the API for NovelEditor (TipTap/ProseMirror JSON).
 * Imported tasks store plain text or markdown; the editor expects a JSON document.
 */
export function parseDescriptionForEditor(description) {
  if (description == null || description === "") {
    return { doc: null, storedString: null };
  }

  if (typeof description !== "string") {
    return { doc: null, storedString: null };
  }

  const trimmed = description.trim();
  if (!trimmed) {
    return { doc: null, storedString: null };
  }

  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed === "object" && parsed.type === "doc") {
      return { doc: parsed, storedString: trimmed };
    }
  } catch {
    // Legacy plain text / markdown from import
  }

  const doc = plainTextToTipTapDoc(trimmed);
  return { doc, storedString: null };
}

function plainTextToTipTapDoc(text) {
  const lines = text.split(/\r?\n/);
  const content = lines.map((line) => {
    if (line) {
      return { type: "paragraph", content: [{ type: "text", text: line }] };
    }
    return { type: "paragraph" };
  });

  return {
    type: "doc",
    content: content.length ? content : [{ type: "paragraph" }],
  };
}
